// Transizioni di stato MANUALI consentite per gli ordini fornitore.
// Specchio ESATTO della mappa autoritativa del backend SUPPLIER_ORDER_STATUS_TRANSITIONS in
// routes/supplier_orders.py (validate_status_sequence rifiuta con 400 ogni altro passaggio):
// - tetto manuale a "Pronto per Spedizione" (6);
// - Spedito (7) / In Transito (8) / Consegnato (9) sono gestiti automaticamente dalle spedizioni;
// - eccezione: "Evaso" (10) ammesso manualmente solo da "Consegnato" (9);
// - "Annullato" (99) a mano solo PRIMA di "In Produzione": da 5 in poi lo stock è caricato
//   in inventario e l'annullamento passa da "Annulla Residuo" (che scarica la produzione non
//   spedita, rispetta le prenotazioni e porta a 99 da solo se non resta nulla).
export const SUPPLIER_ORDER_STATE_TRANSITIONS: { [key: number]: number[] } = {
  1: [2, 3, 99],     // NUOVO → IN ATTESA, CONFERMATO, ANNULLATO
  2: [1, 3, 99],     // IN ATTESA → NUOVO, CONFERMATO, ANNULLATO
  3: [1, 4, 5, 99],  // CONFERMATO → NUOVO, IN LAVORAZIONE, IN PRODUZIONE, ANNULLATO
  4: [3, 5, 99],     // IN LAVORAZIONE → CONFERMATO, IN PRODUZIONE, ANNULLATO
  5: [6],            // IN PRODUZIONE → PRONTO PER SPEDIZIONE (annullamento: Annulla Residuo)
  6: [],             // PRONTO PER SPEDIZIONE → (7 automatico; annullamento: Annulla Residuo)
  7: [],             // SPEDITO → (8 automatico; residuo: Annulla Residuo)
  8: [],             // IN TRANSITO → (9 automatico; residuo: Annulla Residuo)
  9: [10],           // CONSEGNATO → EVASO (manuale per UE/NAZIONALE)
  10: [],            // EVASO → nessuna transizione
  99: [],            // ANNULLATO → nessuna transizione
};

// In creazione un ordine può nascere solo fino a "In Produzione" (5).
export const SUPPLIER_ORDER_CREATABLE_STATUS_IDS: number[] = [1, 2, 3, 4, 5];

// Stati selezionabili in un dropdown di stato ordine fornitore.
// - Creazione (currentStatusId assente): stati creabili (1..5).
// - Modifica/Cambio stato: lo stato attuale (per mostrarlo/mantenerlo) + le transizioni autorizzate.
export const getSelectableSupplierOrderStatusIds = (currentStatusId?: number | null): number[] => {
  if (currentStatusId == null) {
    return [...SUPPLIER_ORDER_CREATABLE_STATUS_IDS];
  }
  const transitions = SUPPLIER_ORDER_STATE_TRANSITIONS[currentStatusId] || [];
  return [currentStatusId, ...transitions];
};
